import { render, staticRenderFns } from "./PPEHome.vue?vue&type=template&id=d4da0504&"
import script from "./PPEHome.vue?vue&type=script&lang=js&"
export * from "./PPEHome.vue?vue&type=script&lang=js&"
import style0 from "./PPEHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports